<template>
  <div class="blog-detail-wrapper p-1">
    <b-row>
      <b-col cols="12" sm="6" md="4" lg="4" class="d-flex flex-column" v-for="product in paginatedPodcast" :key="product.id">
        <router-link
          class="d-flex flex-column flex-grow-1"
          style="margin-bottom: 1rem; text-decoration: none;"
          :to="{ name: 'podcast-detail', params: { id: product.id } }"
          @click.native="goToPodcastDetail(product)"
        >
          <div class="youtube-style-card">
            <div class="thumbnail-wrapper">
              <img
                :src="'https://img.youtube.com/vi/' + getYoutubeId(product.youtubeLink) + '/hqdefault.jpg'"
                :alt="product.title"
                class="thumbnail"
              />
            </div>
            <div class="d-flex mt-2">
              <img :src="`https://ui-avatars.com/api/?name=${product.createdBy || 'User'}&background=random`" class="avatar" />
              <div class="ms-2">
                <h3 class="video-title">{{ product.title }}</h3>
                <div class="meta text-muted">
                  {{ product.views }} views · {{ timeSince(product.publishedAt) }}
                </div>
              </div>
            </div>
          </div>
        </router-link>
      </b-col>
    </b-row>

    <div class="d-flex justify-content-end mt-2">
      <b-pagination
        v-if="totalPodcast > perPage"
        v-model="currentPage"
        :total-rows="totalPodcast"
        :per-page="perPage"
        first-number
        last-number
        class="mb-0 custom-pagination"
        prev-class="prev-item"
        next-class="next-item"
        @input="changePage"
      >
        <template #prev-text>
          <feather-icon icon="ChevronLeftIcon" size="18" />
        </template>
        <template #next-text>
          <feather-icon icon="ChevronRightIcon" size="18" />
        </template>
      </b-pagination>
    </div>
  </div>
</template>

<script>
import {
  BRow, BCol, BPagination
} from 'bootstrap-vue'
import { generateToken } from '@/auth/helperAuth'

export default {
  components: {
    BRow, BCol, BPagination,
  },

  data() {
    return {
      token: '',
      podcast: [],
      perPage: 6,
      currentPage: 1,
      totalPodcast: 0,
    }
  },

  created() {
    const payload = {
      client: "product-catalog-fe",
      kode: this.$store.getters['oauth/getActiveUser'].id.toString(),
      user: this.$store.getters['oauth/getActiveUser'].name,
      role: this.$store.getters['oauth/getActiveUser'].role,
    };
    this.token = generateToken(payload)
  },

  computed: {
    paginatedPodcast() {
      const start = (this.currentPage - 1) * this.perPage
      const end = start + this.perPage
      return this.podcast.slice(start, end)
    },
  },

  mounted() {
    this.fetchPodcast()
  },

  methods: {
    fetchPodcast() {
      this.$http
        .get(`${process.env.VUE_APP_API_HELPER_URL}/podcast?skip=0&limit=100`, {
          headers: {
            Authorization: `${this.token}`,
            Accept: 'application/json'
          }
        })
        .then(({ data }) => {
          this.podcast = data.data.map(item => ({
            id: item.id,
            title: item.title,
            youtubeLink: item.youtube_link,
            description: item.description,
            views: item.total_view || 0,
            publishedAt: item.createdat,
            createdBy: item.createdby,
          }))
          .sort((a, b) => new Date(b.publishedAt) - new Date(a.publishedAt))
          this.totalPodcast = this.podcast.length
        })
        .catch(err => {
          console.error('Failed to fetch podcast:', err)
        })
    },

    getYoutubeId(url) {
      const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=)([^#\&\?]*).*/;
      const match = url.match(regExp);
      return match && match[2].length === 11 ? match[2] : null;
    },

    timeSince(dateStr) {
      const date = new Date(dateStr)
      const seconds = Math.floor((new Date() - date) / 1000)
      const intervals = [
        { label: 'year', seconds: 31536000 },
        { label: 'month', seconds: 2592000 },
        { label: 'day', seconds: 86400 },
        { label: 'hour', seconds: 3600 },
        { label: 'minute', seconds: 60 },
        { label: 'second', seconds: 1 },
      ]

      for (const i of intervals) {
        const count = Math.floor(seconds / i.seconds)
        if (count > 0) {
          return `${count} ${i.label}${count > 1 ? 's' : ''} ago`
        }
      }
      return 'just now'
    },

    goToPodcastDetail(podcast) {
      localStorage.setItem('selectedPodcast', JSON.stringify(podcast));
      const otherVideos = this.podcast.filter(p => p.id !== podcast.id);
      localStorage.setItem('otherVideos', JSON.stringify(otherVideos));
    },

    changePage(page) {
      this.currentPage = page
    }
  }
}
</script>

<style scoped>
.youtube-style-card {
  background-color: transparent;
  border: none;
  border-radius: 8px;
  overflow: hidden;
  padding: 5px;
  width: 100%;
  cursor: pointer;
}

.thumbnail-wrapper {
  position: relative;
  width: 100%;
  padding-top: 56.25%;
  border-radius: 8px;
  overflow: hidden;
}

.thumbnail {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}

.video-title {
  font-size: 0.95rem;
  font-weight: 750;
  margin: 0;
  color: #0f0f0f;
  line-height: 1.3;
  margin-left: 10px;
}

.meta {
  font-size: 0.9rem;
  margin-top: 2px;
  margin-left: 10px;
  color: #606060;
}

.custom-pagination .page-link {
  color: #dc3545;
  border-color: #dc3545;
}

.custom-pagination .page-item.active .page-link {
  background-color: #dc3545;
  border-color: #dc3545;
  color: white;
}

.custom-pagination .page-link:hover {
  background-color: #f8d7da;
  color: #dc3545;
}
</style>
